// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-style {
    position: relative;
    padding-left: 15px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 10px;
    box-sizing: border-box;
    display: block;
    border-bottom: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
    background-color:#f5f5f5;
    -webkit-tap-highlight-color: transparent !important;
    -webkit-font-smoothing: antialiased !important;
}

.sub-heading-style {
    padding: 12px 16px;
}

.main-heading-style {
  padding: 16px 16px;
  font-size: 18px;
}

.case-scans-heading-style {
    font-size: 15px;
}

.add-case-row {
    display: flex;
    overflow: hidden;
    padding: 15px;
    font-size: 13px;
    border-bottom: 1px solid #eee;
}

.user-details {
    display: flex;
    overflow: hidden;
    padding: 15px;
    font-size: 13px;
}

.add-case-row-popup {
    padding-top: 15px;
    font-size: 13px;
}

.add-case-row-header {
    padding-top: 6px;
    font-size: 15px;
}

.input-field-add-case {
    width: 350px;
    color: #000;
    cursor: auto;
}

.input-field-add-user {
    color: #000;
    cursor: auto;
}

.other-field-add-case {
    width: 350px;
}

.submit-row-add-case {
    padding: 12px 14px;
    margin: 0 0 20px;
    background: #f8f8f8;
    border: 1px solid #eee;
  border-radius: 4px;
  text-align: left;
  overflow: hidden;
}

.errors-input {
  border: 1px solid #ba2121;
}

.errormessage {
  margin: 0 0 4px;
  padding: 0;
  color: #ba2121;
  background: #fff;
}

.error-message-general {
    margin-top: 5px;
    padding: 0;
    color: #ba2121;
}


.add-case-button-position, .add-case-button-position:hover {
    padding-right: 26px;
    float: left;
}

.ant-descriptions-item > span {
    display: flex !important;
}

.ant-upload-list-item {
    margin: 0;
}

.history-link-wrapper {
  padding: 8px 32px;
  background-color: #fff;
}

.suffix-right > .ant-input-suffix {
    right: 0;
}

.totp-rules {
  padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/add_case.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,gCAAgC;IAChC,6BAA6B;IAC7B,wBAAwB;IACxB,mDAAmD;IACnD,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,cAAc;AAClB;;;AAGA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;IACI,QAAQ;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":[".heading-style {\n    position: relative;\n    padding-left: 15px;\n    color: rgba(0, 0, 0, 0.85);\n    line-height: 10px;\n    box-sizing: border-box;\n    display: block;\n    border-bottom: 1px solid #d9d9d9;\n    border-top: 1px solid #d9d9d9;\n    background-color:#f5f5f5;\n    -webkit-tap-highlight-color: transparent !important;\n    -webkit-font-smoothing: antialiased !important;\n}\n\n.sub-heading-style {\n    padding: 12px 16px;\n}\n\n.main-heading-style {\n  padding: 16px 16px;\n  font-size: 18px;\n}\n\n.case-scans-heading-style {\n    font-size: 15px;\n}\n\n.add-case-row {\n    display: flex;\n    overflow: hidden;\n    padding: 15px;\n    font-size: 13px;\n    border-bottom: 1px solid #eee;\n}\n\n.user-details {\n    display: flex;\n    overflow: hidden;\n    padding: 15px;\n    font-size: 13px;\n}\n\n.add-case-row-popup {\n    padding-top: 15px;\n    font-size: 13px;\n}\n\n.add-case-row-header {\n    padding-top: 6px;\n    font-size: 15px;\n}\n\n.input-field-add-case {\n    width: 350px;\n    color: #000;\n    cursor: auto;\n}\n\n.input-field-add-user {\n    color: #000;\n    cursor: auto;\n}\n\n.other-field-add-case {\n    width: 350px;\n}\n\n.submit-row-add-case {\n    padding: 12px 14px;\n    margin: 0 0 20px;\n    background: #f8f8f8;\n    border: 1px solid #eee;\n  border-radius: 4px;\n  text-align: left;\n  overflow: hidden;\n}\n\n.errors-input {\n  border: 1px solid #ba2121;\n}\n\n.errormessage {\n  margin: 0 0 4px;\n  padding: 0;\n  color: #ba2121;\n  background: #fff;\n}\n\n.error-message-general {\n    margin-top: 5px;\n    padding: 0;\n    color: #ba2121;\n}\n\n\n.add-case-button-position, .add-case-button-position:hover {\n    padding-right: 26px;\n    float: left;\n}\n\n.ant-descriptions-item > span {\n    display: flex !important;\n}\n\n.ant-upload-list-item {\n    margin: 0;\n}\n\n.history-link-wrapper {\n  padding: 8px 32px;\n  background-color: #fff;\n}\n\n.suffix-right > .ant-input-suffix {\n    right: 0;\n}\n\n.totp-rules {\n  padding: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
